import {
  QueryDocumentSnapshot,
  DocumentData,
  FirestoreDataConverter,
  WithFieldValue,
  SnapshotOptions,
} from "firebase/firestore";
import { IDevice } from "./device";

export interface IHouse {
  id: string;
  blok: string;
  houseType: string;
  isConfigured: boolean;
  status: boolean;
  devices: IDevice[];
}

export type IHouseFormPayload = Omit<IHouse, "id" | "devices">;

export const houseConverter: FirestoreDataConverter<IHouse> = {
  toFirestore(house: WithFieldValue<IHouse>): DocumentData {
    return house;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
  ): IHouse {
    const data = snapshot.data(options);
    return {
      blok: data.blok,
      houseType: data.houseType,
      id: snapshot.id,
      devices: data.devices,
      isConfigured: data.isConfigured,
      status: data.status,
    };
  },
};
